var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25293 1.3335L9.7619 5.25681C9.97341 5.80673 10.0792 6.08169 10.2436 6.31298C10.3894 6.51796 10.5685 6.69706 10.7734 6.84281C11.0047 7.00727 11.2797 7.11302 11.8296 7.32453L15.7529 8.8335L11.8296 10.3425C11.2797 10.554 11.0047 10.6597 10.7735 10.8242C10.5685 10.9699 10.3894 11.149 10.2436 11.354C10.0792 11.5853 9.97341 11.8603 9.7619 12.4102L8.25293 16.3335L6.74396 12.4102C6.53245 11.8603 6.4267 11.5853 6.26224 11.354C6.11649 11.149 5.93739 10.9699 5.73241 10.8242C5.50113 10.6597 5.22617 10.554 4.67624 10.3425L0.75293 8.8335L4.67624 7.32453C5.22617 7.11302 5.50113 7.00727 5.73241 6.84281C5.93739 6.69706 6.11649 6.51796 6.26224 6.31298C6.4267 6.08169 6.53245 5.80673 6.74396 5.25681L8.25293 1.3335Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar);
export default __webpack_public_path__ + "static/media/ai-star.7bce545391012f1f7a34ed00994b83f0.svg";
export { ForwardRef as ReactComponent };